"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyLoadImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LazyLoad_1 = require("./LazyLoad");
/**
 * A lazy loaded image
 */
var LazyLoadImage = function (_a) {
    var height = _a.height, width = _a.width, getSrc = _a.getSrc, transition = _a.transition;
    var imageRef = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)(false), 2), loaded = _b[0], setLoaded = _b[1];
    var onLazyLoad = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var src;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getSrc()];
                case 1:
                    src = _a.sent();
                    if (!src) {
                        return [2 /*return*/];
                    }
                    if (!imageRef.current) {
                        return [2 /*return*/];
                    }
                    imageRef.current.src = src;
                    return [2 /*return*/];
            }
        });
    }); }, [getSrc]);
    var onImgLoad = (0, react_1.useCallback)(function () {
        setLoaded(true);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(LazyLoad_1.LazyLoad, { minHeight: height, minWidth: width, onLazyLoad: onLazyLoad, style: {
            height: height,
            width: width,
            position: "relative",
        }, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    backgroundColor: "#44444444",
                    opacity: loaded ? "0" : "1",
                    transition: transition !== null && transition !== void 0 ? transition : "all 0.3s",
                    zIndex: loaded ? "-1" : "1",
                } }), (0, jsx_runtime_1.jsx)("img", { alt: "LazyLoadImage", ref: imageRef, onError: function (e) {
                    var _a;
                    console.error("Unable to load image. src = ".concat((_a = imageRef.current) === null || _a === void 0 ? void 0 : _a.src));
                }, onLoad: onImgLoad, style: {
                    objectFit: "cover",
                    width: width,
                    height: height,
                    opacity: loaded ? "1" : "0",
                    transition: transition !== null && transition !== void 0 ? transition : "all 0.3s",
                } })] }));
};
exports.LazyLoadImage = LazyLoadImage;
